import flatMap from "lodash/flatMap";
import compact from "lodash/compact";
import useMapKeys from "views/components/visualizations/useMapKeys";
import { keySeparator, humanSeparator } from "views/Constants";
import useQueryFieldTypes from "views/hooks/useQueryFieldTypes";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
const useXAxisTicksAndType = (config, chartData) => {
  var _a, _b;
  const mapKeys = useMapKeys();
  const fieldTypes = useQueryFieldTypes();
  if (config.isTimeline) return {};
  const tickvals = compact(flatMap(chartData, "x"));
  const rowPivotFields = (_b = (_a = config == null ? void 0 : config.rowPivots) == null ? void 0 : _a.flatMap((pivot) => pivot.fields)) != null ? _b : [];
  const isCategoryType = rowPivotFields.length === 1 && (!fieldTypeFor(rowPivotFields[0], fieldTypes).isNumeric() || tickvals.some((v) => {
    const convertedValue = Number(v);
    return Number.isNaN(convertedValue) || !Number.isInteger(convertedValue);
  }));
  return {
    tickvals,
    ticktext: tickvals.map(
      (label) => label.split(keySeparator).map((l, i) => mapKeys(l, rowPivotFields[i])).join(humanSeparator)
    ),
    type: isCategoryType ? "category" : void 0
  };
};
export default useXAxisTicksAndType;
